import {
  BAYWA_SCREEN_USER,
  useGetUserUtils,
  useQueryUserData,
} from '~/data/user';

import AuthService from '~/services/auth.service';

export type BugReportWidgetVariant = 'custom' | 'sentry' | 'none';

/**
 * Decides which bug-report widget to mount for the current user:
 * the custom bug report or the Sentry feedback widget.
 */
export function useBugReportWidget(): BugReportWidgetVariant {
  const { data: currentUser } = useQueryUserData(true);
  const { UserUtils } = useGetUserUtils();

  if (!currentUser) {
    return 'none';
  }

  if (AuthService.getUserIdFromAccessToken() === BAYWA_SCREEN_USER) {
    return 'none';
  }

  if (UserUtils.isVestigasAccount()) {
    return 'custom';
  }

  return 'sentry';
}
